export type TBusyValue = string | number | number[];

export const busyIncludes = (
  busy: TBusyValue[],
  item: { [index: string]: any }
): boolean => {
  let result = false;
  if (typeof item.value === "string") {
    return busy.includes(item.value);
  } else {
    for (let i = 0; i < busy.length; i++) {
      if (typeof busy[i] === "string") continue;
      const [minValue, maxValue] = item.value;
      if (typeof busy[i] === "number") {
        result = busy[i] > minValue && busy[i] <= maxValue;
        if (result) break;
      } else {
        const b = busy[i] as number[];
        result = b[0] === minValue && b[1] === maxValue;
        if (result) break;
      }
    }
  }
  return result;
};
